import {
  DISCONNECT_PPTOX_SERVER_API,
  SIGNING_CERTIFICATE_API,
  GET_SETTINGS_API,
  UPDATE_PPTOX_SSO_PROVISIONING_API,
  UPDATE_SETTINGS_API
} from '~/constants/APIs'
import { IPTToXSSOFrom, ISettingForm, SettingsData } from '~/models'
import axiosClient from './axiosClient'

export const settingApis = {
  getSettings: () => axiosClient.get(GET_SETTINGS_API) as unknown as SettingsData,
  updateSettings: (data: ISettingForm) => axiosClient.patch(UPDATE_SETTINGS_API, data),
  updateSSOProvisioning: (data: IPTToXSSOFrom) =>
    axiosClient.post(UPDATE_PPTOX_SSO_PROVISIONING_API, data),
  disconnectSSOServer: () => axiosClient.post(DISCONNECT_PPTOX_SERVER_API),
  downloadCertificate: () =>
    axiosClient.get(SIGNING_CERTIFICATE_API, { responseType: 'blob' }),
  revokeCertificate: () => axiosClient.delete(SIGNING_CERTIFICATE_API),
  createCertificate: () => axiosClient.post(SIGNING_CERTIFICATE_API)
}
